import { render, staticRenderFns } from "./CustomerAddressFormPartial.vue?vue&type=template&id=2cf49658&"
import script from "./CustomerAddressFormPartial.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressFormPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports